import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useResearchCenterDelete } from '../model/ResearchCenterQuery';

interface ResearchCenterDeleteButtonProps {
  researchCenter: Id;
}

export function ResearchCenterDeleteButton({ researchCenter }: ResearchCenterDeleteButtonProps) {
  const mutation = useResearchCenterDelete(researchCenter);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
